import styled from "styled-components";
import { ErrorMessage, Field, Formik, Form } from "formik";
import { validationLogin } from "../../validations/ValidationLogin";
import { PrivatePath, PublicPath } from "../../routers/paths";
import { useNavigate } from "react-router-dom";
import { LoginHeader } from "./LoginHeader";
import { useDispatch } from "react-redux";
import { onGetAdminInfo, onLoginAdmin } from "../../redux/auth/thunk";
import { message } from "antd";
import { useState } from "react";

const Container = styled.div`
	min-height: 448px;
	min-width: 456px;
`;

const LoginForm = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showPassword, setShowPassword] = useState(false);


    const onSubmit = async ({ user, password }, { setSubmitting, resetForm }) => {
        try {
            const result = await dispatch(onLoginAdmin({ email: user, password: password }))
            if (result) {
                // message.success("login ok cargando...")
                const adminInfo = await dispatch(onGetAdminInfo())
                // message.success(`Hola ${adminInfo.payload.name}`)
                switch (adminInfo.payload.typeUser) {
                    case "VRL":
                        navigate('/' + PrivatePath.vrLearning + PrivatePath.client)
                        break;
                    case "VRT":
                        navigate('/' + PrivatePath.vrTraining + PrivatePath.client)
                        break;
                    case "INMERSYS":
                        navigate('/' + PrivatePath.vrLearning + PrivatePath.inmersys)
                        break;
                    default:
                        navigate('/auth')
                        break
                }
                resetForm({});
            }
        } catch (error) {
            message.error("error")
            setSubmitting(false);
        }
    };
    return (
        <Container>
            <LoginHeader />
            <Formik
                initialValues={{
                    // user: "colgate@inmersys.com",
                    user: "",
                    // password: "11111111",
                    password: "",
                }}
                validationSchema={validationLogin}
                onSubmit={onSubmit}
            >
                {({ handleSubmit, handleChange, values }) => (
                    <Form onSubmit={handleSubmit}>
                        <div className="mb-4 h-20 ">
                            <Field
                                className="w-full text-white p-4 bg-transparent border-b text-base focus:outline-none  border-white placeholder:text-white"
                                type="text"
                                placeholder="Correo electrónico"
                                name="user"
                                onChange={handleChange}
                                value={values.user}
                                autoComplete="none"
                            />
                            <ErrorMessage component="a" className="text-red-600 " name="user" />
                        </div>
                        <div className="mb-4 flex h-20">
                            <Field
                                className="w-full p-4 text-white bg-transparent border-b text-base focus:outline-none border-white placeholder:text-white"
                                type={showPassword ? "text" : "password"}
                                placeholder="Contraseña"
                                name="password"
                                onChange={handleChange}
                                value={values.password}
                                autoComplete="none"
                            />
                            <button
                                type="button"
                                className="text-white border-b border-white"
                                onClick={() => setShowPassword((prev) => !prev)}
                            >
                                {showPassword ?
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M3.97993 8.22257C3.05683 9.31382 2.35242 10.596 1.93436 12.0015C3.22565 16.338 7.24311 19.5 11.9991 19.5C12.9917 19.5 13.9521 19.3623 14.8623 19.1049M6.22763 6.22763C7.88389 5.13558 9.86771 4.5 12 4.5C16.756 4.5 20.7734 7.66205 22.0647 11.9985C21.3528 14.3919 19.8106 16.4277 17.772 17.772M6.22763 6.22763L3 3M6.22763 6.22763L9.87868 9.87868M17.772 17.772L21 21M17.772 17.772L14.1213 14.1213M14.1213 14.1213C14.6642 13.5784 15 12.8284 15 12C15 10.3431 13.6569 9 12 9C11.1716 9 10.4216 9.33579 9.87868 9.87868M14.1213 14.1213L9.87868 9.87868" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    :
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M2.03555 12.3224C1.96647 12.1151 1.9664 11.8907 2.03536 11.6834C3.42372 7.50972 7.36079 4.5 12.0008 4.5C16.6387 4.5 20.5742 7.50692 21.9643 11.6776C22.0334 11.8849 22.0335 12.1093 21.9645 12.3166C20.5761 16.4903 16.6391 19.5 11.9991 19.5C7.36119 19.5 3.42564 16.4931 2.03555 12.3224Z" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                }
                            </button>
                        </div>
                        <ErrorMessage component="a" className="text-red-600 " name="password" />
                        <p
                            onClick={() => { navigate(PublicPath.restorePassword) }}
                            className=" cursor-pointer text-center text-white text-base font-normal my-9">¿Olvidaste tu contraseña?</p>
                        <div className="mb-3 flex h-full justify-center">
                            <button type="submit" className="w-[236px] h-12 bg-[#3366FF] hover:bg-[#4070FF] focus:bg-[#254ABB] text-white font-normal text-base rounded-md">
                                Entrar
                            </button>
                        </div>
                    </Form>
                )}
            </Formik>
        </Container>
    );
};

export default LoginForm;
